// Entry point for the build script in your package.json
import '@hotwired/turbo-rails'
import './controllers'

import { Application } from '@hotwired/stimulus'
import { Popover } from 'tailwindcss-stimulus-components'
import { wrapViewTransition } from './helpers/view_transitions'

const application = Application.start()
application.register('popover', Popover)

// import flatpickr from "flatpickr";

window.addEventListener('turbo:before-frame-render', (event) => {
  if (event.detail.newFrame.hasAttribute('data-turbo-frame-view-transition')) {
    const originalRender = event.detail.render
    event.detail.render = (currentElement, newElement) => {
      wrapViewTransition(() => originalRender(currentElement, newElement))
    }
  }
})

window.addEventListener('turbo:before-frame-render', (event) => {
  if (event.target.getAttribute('scroll') === 'preserve' && event.detail.newFrame.getAttribute('scroll') === 'preserve') {
    const originalRender = event.detail.render
    event.detail.render = async (currentElement, newElement) => {
      const scrollPosition = event.target.firstElementChild?.scrollTop
      await originalRender(currentElement, newElement)
      if (scrollPosition) {
        event.target.firstElementChild.scrollTop = scrollPosition
      }
    }
  }
})
